/**
 * التقارير — the Reports page. New in Rawam 7, so there is no legacy resx behind any of it;
 * the English lives in scripts/i18n/strings.en.json like every other feature's.
 *
 * Wording rules (RAWAM-REPORTS-REDESIGN-PLAN.md §5): a rate always names what it is a share
 * OF; a change is said in words ("انخفض") as well as a figure; nothing reads as a verdict.
 */
export const strings = {
  title: 'التقارير',
  subtitle: 'مؤشرات برنامج التوعية حسب الفترة والإدارة',

  /* The five headline cards on نظرة عامة (/general) — organisation level only. */
  headline: {
    title: 'مؤشرات برنامج التوعية',
    note: 'للمنظمة كلها. التفصيل حسب الإدارة وأسماء من يحتاجون إلى متابعة في التقارير.',
    open: 'التقارير التفصيلية',
  },

  /* The executive summary as a PDF (plan §6.6). */
  pdf: {
    action: 'الملخص التنفيذي (PDF)',
    title: 'الملخص التنفيذي للتوعية الأمنية',
    confidential: 'وثيقة داخلية',
    footer: 'روام — منصة التوعية بالأمن السيبراني',
    departments: 'الإدارات',
    population: 'الموظفون المشمولون',
    preparedBy: 'أعده',
    preparedOn: 'تاريخ الإعداد',
    overview: 'الصورة العامة',
    overviewNote: 'رقم واحد لكل مجال من البرنامج خلال الفترة.',
    incidents: 'بلاغات صحيحة',
    followUp: 'تحتاج إلى متابعة',
    followUpNote: 'عدد الموظفين في كل قائمة، والقوائم كاملة في صفحة المتابعة.',
    byDepartment: 'الإدارات',
    byDepartmentMore: 'الإدارات (تابع)',
    department: 'الإدارة',
    employees: 'الموظفون',
    organisation: 'المنظمة كاملة',
    /* The department table's columns — ReportsEngine.Summary's matrix keys. */
    columns: {
      trainingCompletion: 'أكملوا التدريب',
      assessmentPass: 'اجتازوا القياسات',
      clickRate: 'نقروا على التصيد',
      reportRate: 'أبلغوا عن التصيد',
      policyAcknowledgement: 'أقروا بالسياسات',
    },
    missing: '— لا توجد بيانات، أو المجموعة أقل من',
    missingUnit: 'موظفين فلا تعرض نسبتها.',
    quiet: 'إدارات لا تعرض لها نسب:',
    separator: '، ',
    asOf: 'البيانات حتى',
  },

  sections: {
    summary: 'الملخص التنفيذي',
    phishing: 'السلوك تجاه التصيد',
    knowledge: 'المعرفة',
    training: 'التغطية التدريبية',
    policies: 'الالتزام بالسياسات',
    incidents: 'الإبلاغ عن الحوادث',
    followUp: 'المتابعة',
  },

  /* The section strip: one word each, the titles above are the headings. */
  tabs: {
    summary: 'الملخص',
    phishing: 'التصيد',
    knowledge: 'المعرفة',
    training: 'التدريب',
    policies: 'السياسات',
    incidents: 'الحوادث',
    followUp: 'المتابعة',
  },

  /* The question each section answers, under its heading. */
  questions: {
    summary: 'هل تنخفض نسبة النقر ويرتفع الإبلاغ؟ هل اكتملت التغطية؟ وأين تحتاج الإدارات إلى متابعة؟',
    phishing: 'من ينقر أو يدخل بيانات، ومن يبلغ وبأي سرعة، وهل يتغير ذلك من حملة إلى أخرى؟',
    knowledge: 'من أجرى التقييم ومن اجتازه، وما المواضيع الأضعف؟',
    training: 'الإكمال يقيس التعرض للمحتوى، لا انخفاض المخاطر.',
    policies: 'هل أقر كل من صدرت له السياسة بإصدارها الحالي؟',
    incidents: 'هل يبلغ الموظفون عن الأحداث المشبوهة، وكم منها يثبت؟',
    followUp: 'أسماء من يحتاجون إلى إجراء، مع تصدير كل قائمة كاملة.',
  },

  filters: {
    label: 'نطاق التقرير',
    period: 'الفترة',
    periods: {
      quarter: 'آخر ربع مكتمل',
      last30: 'آخر 30 يوما',
      last12: 'آخر 12 شهرا',
      ytd: 'منذ بداية السنة',
      custom: 'فترة مخصصة',
    },
    from: 'من',
    to: 'إلى',
    compare: 'المقارنة',
    compares: {
      previous: 'مع الفترة السابقة',
      year: 'مع الفترة نفسها من العام الماضي',
      none: 'بدون مقارنة',
    },
    departments: 'الإدارات',
    allDepartments: 'كل الإدارات',
    departmentsCount: 'إدارات محددة',
    pickDepartments: 'اختيار الإدارات',
    selectAll: 'تحديد الكل',
    searchDepartments: 'ابحث عن إدارة',
    noDepartments: 'لا توجد إدارة بهذا الاسم',
    apply: 'تطبيق',
    clear: 'كل الإدارات',
    departmentsHint: 'تعرض الإدارات التي فيها موظفون ضمن النطاق. المجموعات المخصصة ليست إدارات.',
  },

  meta: {
    comparedWith: 'مقارنة مع',
    asOf: 'الحالة حتى',
    updated: 'آخر تحديث',
    inScope: 'ضمن النطاق',
    people: 'موظف',
    populationTitle: 'من تشملهم الأرقام',
    populationHint:
      'الموظفون المفعلون الذين يحملون دور المتدرب ولم يغادروا حتى نهاية الفترة. لا يحسب حساب مدير النظام.',
    excluded: {
      awaitingActivation: 'بانتظار التفعيل',
      suspended: 'موقوفون',
      leftOrExpired: 'غادروا أو انتهت حساباتهم',
      withoutDepartment: 'بدون إدارة (ضمن النطاق)',
    },
    suppression: 'تخفى النسب في التفصيل للمجموعات الأقل من',
    suppressionUnit: 'أشخاص',
  },

  actions: {
    refresh: 'تحديث الأرقام',
    refreshed: 'تم تحديث الأرقام',
    export: 'تصدير',
    exportAll: 'التقرير كاملا (Excel)',
    exportSection: 'فقط (Excel)', // after the tab's name: التدريب فقط (Excel)
    exportList: 'تصدير القائمة',
    exported: 'تم تجهيز الملف',
    exportFailed: 'تعذر تصدير الملف',
    showTable: 'عرض كجدول',
    showChart: 'عرض كرسم',
    retry: 'إعادة المحاولة',
    back: 'التقارير',
    openList: 'عرض القائمة',
    openProfile: 'ملف الإدارة',
  },

  states: {
    loadFailed: 'تعذر تحميل هذا القسم',
    loadFailedHint: 'بقية الأقسام متاحة. أعد المحاولة بعد قليل.',
    invalidScope: 'نطاق التقرير غير صالح',
    invalidScopeHint: 'تحقق من التاريخين. أقصى طول للفترة ثلاث سنوات.',
    empty: 'لا توجد بيانات في هذه الفترة',
    emptyHint: 'جرب فترة أطول من قائمة الفترة.',
    widen: 'آخر 12 شهرا',
    slow: 'ما زال الحساب جاريا، قد يستغرق ذلك بضع ثوان.',
    notFound: 'الإدارة غير موجودة',
    notFoundHint: 'ربما حذفت أو لا يوجد فيها موظفون ضمن النطاق.',
  },

  /* Every department of a section on one chart, against the organisation (DepartmentStanding). */
  standing: {
    departments: 'الإدارات',
    departmentsCount: 'إدارة',
    behind: 'متأخرة عن المنظمة',
    behindCount: 'متأخرة عن خط المنظمة',
    organisation: 'المنظمة',
    interval: 'نطاق الثقة 95%',
    metric: 'المؤشر',
    withheld: 'إدارات لا تظهر لأن عدد أفرادها أقل من الحد الأدنى للعرض:',
    hint: 'كل نقطة نسبة إدارة، والشريط خلفها نطاق الثقة 95%، والخط المتقطع نسبة المنظمة. المثلث إدارة يقع نطاقها كله في الجانب الأسوأ من خط المنظمة. انقر نقطة لفتح ملف الإدارة.',
  },

  /* Under a section's headline row: what every change in it is measured against. */
  ledger: {
    previous: 'العلامة على كل شريط والتغير بالنقاط: مقارنة بالفترة السابقة',
    year: 'العلامة على كل شريط والتغير بالنقاط: مقارنة بالفترة نفسها من العام الماضي',
  },

  /* Long lists are bounded: what is on screen, of how many, and the way to the rest. */
  table: {
    search: 'ابحث بالاسم',
    of: 'من أصل',
    showing: 'يعرض',
    showAll: 'عرض الكل',
    showLess: 'عرض أقل',
    noMatch: 'لا توجد نتائج مطابقة',
  },

  indicators: {
    clickRate: 'نسبة النقر',
    submitRate: 'نسبة إدخال البيانات',
    reportRate: 'نسبة الإبلاغ',
    reportedWithoutClick: 'أبلغوا دون أن ينقروا',
    employeesClicked: 'موظفون نقروا',
    assessmentPass: 'اجتياز التقييم',
    assessmentParticipation: 'المشاركة في التقييم',
    examFirstAttemptPass: 'الاجتياز من المحاولة الأولى',
    trainingCompletion: 'إكمال التدريب',
    trainingStarted: 'بدء التدريب',
    activeLearners: 'متعلمون نشطون',
    policyAcknowledgement: 'الإقرار بالسياسات',
    reporterParticipation: 'المشاركة في الإبلاغ',
    validShare: 'بلاغات ثبتت صحتها',
  },

  /* What each figure counts. Shown behind the (i) beside it. */
  definitions: {
    clickRate: 'من الرسائل التي وصلت في حملات أطلقت خلال الفترة: نسبة ما نقر مستلمه الرابط.',
    submitRate: 'من الرسائل التي وصلت: نسبة ما أدخل مستلمه بيانات في صفحة التصيد.',
    reportRate: 'من الرسائل التي وصلت: نسبة ما أبلغ عنه مستلمه.',
    reportedWithoutClick: 'من الرسائل التي وصلت: نسبة ما أبلغ عنه مستلمه دون أن ينقر.',
    employeesClicked: 'من الموظفين الذين وصلتهم رسالة واحدة على الأقل: نسبة من نقر في أي منها.',
    assessmentPass: 'من الموظفين الذين أكملوا تقييما خلال الفترة: نسبة من اجتازه.',
    assessmentParticipation: 'من الموظفين المكلفين بتقييم خلال الفترة: نسبة من أكمله.',
    examFirstAttemptPass: 'من اختبارات الدورات التي أجريت أول مرة خلال الفترة: نسبة ما اجتيز من المحاولة الأولى.',
    trainingCompletion: 'من تكليفات البرامج حتى نهاية الفترة: نسبة ما أكمل.',
    trainingStarted: 'من تكليفات البرامج حتى نهاية الفترة: نسبة ما بدأ.',
    activeLearners: 'من الموظفين ضمن النطاق: نسبة من سجل نشاطا تعليميا خلال الفترة.',
    policyAcknowledgement: 'من تكليفات السياسات المفعلة: نسبة ما أقر به على الإصدار الحالي حتى نهاية الفترة.',
    reporterParticipation: 'من الموظفين ضمن النطاق: نسبة من أرسل بلاغا حقيقيا واحدا على الأقل خلال الفترة.',
    validShare: 'من البلاغات التي أغلقت مراجعتها: نسبة ما ثبت أنه حادث فعلي.',
  },

  /* What one unit of the denominator is — "12 / 340 رسالة". */
  units: {
    email: 'رسالة',
    person: 'موظف',
    assignment: 'تكليف',
    exam: 'اختبار',
    report: 'بلاغ',
    campaign: 'حملة',
    assessment: 'تقييم',
    attempt: 'محاولة',
    minute: 'دقيقة',
    hour: 'ساعة',
    day: 'يوم',
    programme: 'برنامج',
    policy: 'سياسة',
  },

  /* StatDto keys — figures that are not proportions. */
  stats: {
    campaigns: 'الحملات',
    repeatClickers: 'نقروا في أكثر من حملة',
    medianMinutesToReport: 'وسيط زمن الإبلاغ',
    medianMinutesToClick: 'وسيط زمن النقر',
    assessments: 'التقييمات',
    medianAttemptsToPass: 'وسيط المحاولات حتى الاجتياز',
    overdue: 'تكليفات متأخرة',
    programmes: 'البرامج',
    personsCompletedAll: 'أكملوا كل برامجهم',
    pending: 'إقرارات معلقة',
    rejected: 'رفضوا',
    medianDaysToAcknowledge: 'وسيط أيام الإقرار',
    policiesWithoutAudience: 'سياسات بلا جمهور',
    reports: 'البلاغات',
    simulatedExcluded: 'بلاغات محاكاة مستبعدة',
    anonymous: 'بلاغات بدون اسم',
    medianHoursToFirstResponse: 'وسيط زمن أول استجابة',
  },

  reasons: {
    noCampaign: 'لا توجد حملات أطلقت في هذه الفترة',
    noAudience: 'لا يوجد مكلفون',
    noAssessment: 'لا يوجد تقييم في هذه الفترة',
    notMeasurable: 'غير قابل للقياس في هذه الفترة',
    noData: 'لا توجد بيانات',
  },

  delta: {
    up: 'ارتفع',
    down: 'انخفض',
    flat: 'دون تغيير',
    points: 'نقطة',
    previous: 'عن الفترة السابقة',
    year: 'عن العام الماضي',
    before: 'سابقا',
  },

  mix: {
    measuredOn: 'قيست على',
    campaigns: 'حملات',
    easy: 'سهل',
    normal: 'متوسط',
    hard: 'صعب',
    unrated: 'دون مستوى',
  },

  difficulty: { 0: 'سهل', 1: 'متوسط', 2: 'صعب' },
  payload: { 0: 'موقع إصطياد', 1: 'مرفقات خبيثة', 2: 'طلب معلومات' },

  cell: {
    behind: 'متأخرة',
    behindHint: 'نطاق الثقة 95% لهذه الإدارة يقع كله في الجانب الأسوأ من نسبة المنظمة.',
    fewer: 'أقل من',
    fewerHint: 'عدد الأشخاص أقل من الحد الأدنى للعرض، فتخفى النسبة حماية للخصوصية.',
  },

  lists: {
    clicked: 'نقروا أو أدخلوا بيانات',
    repeatClickers: 'نقروا في أكثر من حملة',
    overdueTraining: 'متأخرون في التدريب',
    pendingPolicies: 'بانتظار الإقرار بالسياسات',
    assessmentNotTaken: 'لم يشاركوا في القياسات',
    failedAssessment: 'لم يجتازوا القياسات',
  },

  listHints: {
    clicked: 'كل من نقر أو أدخل بيانات في حملة أطلقت خلال الفترة، مع أبعد مرحلة وصل إليها.',
    repeatClickers: 'من نقر في حملتين أو أكثر خلال الفترة.',
    overdueTraining: 'تكليفات تجاوزت آخر موعد لدوراتها ولم تكتمل حتى نهاية الفترة.',
    pendingPolicies: 'تكليفات سياسات مفعلة لم يقر بها على الإصدار الحالي، مع السبب.',
    assessmentNotTaken: 'من كلف بقياس يتقاطع مع الفترة ولم يكمله.',
    failedAssessment: 'من أكمل القياس ولم يجتزه.',
  },

  summary: {
    indicators: 'المؤشرات الرئيسية',
    needsAction: 'تحتاج إلى إجراء',
    needsActionHint: 'أعداد تفتح قائمة الأسماء التي وراءها.',
    trend: 'النقر والإبلاغ لكل حملة',
    trendScope: 'الحملات التي أطلقت خلال 12 شهرا حتى نهاية الفترة',
    trendEmpty: 'لا توجد حملات في آخر 12 شهرا',
    matrix: 'الإدارات مقابل المنظمة',
    matrixRule:
      'تعلم الخلية بـ «متأخرة» عندما يقع نطاق الثقة 95% للإدارة كله في الجانب الأسوأ من نسبة المنظمة. مع كثرة الإدارات قد تظهر بعض العلامات بالصدفة.',
    matrixEmpty: 'لا توجد إدارات فيها موظفون ضمن النطاق',
    behindIn: 'مؤشرات متأخرة',
    flagged: 'متأخرة في مؤشر واحد على الأقل',
    behindOnly: 'المتأخرة فقط',
    showCounts: 'إظهار الأعداد',
    organisation: 'المنظمة',
    pooled: 'تقييمات مجمعة',
    participation: 'المشاركة',
    coverage: 'التغطية ربع سنويا',
    coverageScope: 'من آخر لقطة يومية في كل ربع، ولا تتغير بعد تسجيلها',
    coverageEmpty: 'لا توجد لقطات بعد. يبدأ السجل من يوم تفعيل هذه الميزة ويحدث كل ليلة.',
    coverageSince: 'يبدأ السجل في',
    quarter: 'الربع',
  },

  columns: {
    department: 'الإدارة',
    members: 'الموظفون',
    name: 'الاسم',
    campaign: 'الحملة',
    launched: 'تاريخ الإطلاق',
    category: 'التصنيف',
    difficulty: 'المستوى',
    payload: 'المحتوى',
    delivered: 'وصلت',
    opened: 'فتحت أو تفاعل معها',
    clicked: 'نقر',
    submitted: 'أدخل بيانات',
    reported: 'أبلغ',
    reportedWithoutClick: 'أبلغ دون نقر',
    medianReport: 'وسيط زمن الإبلاغ',
    template: 'القالب',
    campaigns: 'الحملات',
    assessment: 'التقييم',
    window: 'فترة التقييم',
    audience: 'المكلفون',
    completers: 'أكملوا',
    participation: 'المشاركة',
    passed: 'اجتازوا',
    meanScore: 'متوسط الدرجة',
    topic: 'الموضوع',
    people: 'الأشخاص',
    items: 'الإجابات',
    correct: 'إجابات صحيحة',
    course: 'الدورة',
    firstAttempt: 'من المحاولة الأولى',
    medianAttempts: 'وسيط المحاولات',
    programme: 'البرنامج',
    dueDate: 'آخر موعد',
    assigned: 'المكلفون',
    notStarted: 'لم يبدأ',
    inProgress: 'قيد التقدم',
    completedFailed: 'أكمل ولم يجتز',
    completedPassed: 'أكمل واجتاز',
    completed: 'أكملوا',
    overdue: 'متأخر',
    completion: 'الإكمال',
    medianDays: 'وسيط الأيام',
    activeLearners: 'متعلمون نشطون',
    bulletin: 'النشرة',
    published: 'تاريخ النشر',
    reach: 'الوصول',
    survey: 'الاستبيان',
    response: 'الاستجابة',
    policy: 'السياسة',
    version: 'الإصدار',
    acknowledged: 'أقروا',
    rejected: 'رفضوا',
    notOpened: 'لم يطلعوا',
    downloadedOnly: 'حملوا ولم يقروا',
    olderVersionOnly: 'أقروا بإصدار سابق',
    pending: 'معلق',
    rate: 'نسبة الإقرار',
    parent: 'التصنيف الرئيسي',
    reports: 'البلاغات',
    population: 'الموظفون',
    reporters: 'المبلغون',
    username: 'اسم المستخدم',
    employeeId: 'الرقم الوظيفي',
    item: 'البند',
    status: 'الحالة',
    date: 'التاريخ',
    days: 'الأيام',
    value: 'العدد',
    score: 'الدرجة',
    phishing: 'التصيد',
    training: 'التدريب',
    policies: 'السياسات',
    assessmentResult: 'التقييم',
  },

  phishing: {
    campaigns: 'الحملات',
    campaignsHint: 'الحملات التي أطلقت خلال الفترة، والنسب من الرسائل التي وصلت.',
    trend: 'النقر والإبلاغ لكل حملة',
    departments: 'حسب الإدارة',
    departmentsHint: 'نسب مجمعة لكل رسالة، حسب إدارة المستلم وقت الإطلاق.',
    templates: 'حسب القالب',
    templatesHint: 'نسبة النقر لكل رسالة، من القوالب الأكثر نقرا. الخط المتقطع نسبة المنظمة.',
    scannerCaveat: 'لا تستبعد النقرات الآلية من أنظمة فحص البريد بعد، فقد تكون نسبة النقر أعلى من الواقع.',
    difficultyCaveat: 'تعتمد المقارنة بين الفترات على مستوى صعوبة الحملات.',
    classifiedNote: 'استبعد من نسبة النقر من لم يلمس رسالته إلا نظام فحص آلي، وعددهم',
    openedNote: 'تظهر للحملات التي فيها بكسل تتبع فقط.',
    minutes: 'دقيقة',
    noCampaigns: 'لا توجد حملات أطلقت في هذه الفترة',
  },

  knowledge: {
    assessments: 'التقييمات',
    assessmentsHint: 'التقييمات التي تتقاطع فترتها مع فترة التقرير. اختر تقييما لعرض توزيع درجاته.',
    distribution: 'توزيع الدرجات',
    distributionHint: 'عدد من أكملوا التقييم في كل شريحة من عشر درجات.',
    pickAssessment: 'اختر تقييما من الجدول',
    topics: 'المواضيع',
    topicsHint: 'نسبة الإجابات الصحيحة في كل موضوع، من المحاولات المكتملة. الأضعف أولا.',
    topicsEmpty: 'لا توجد إجابات مصنفة بمواضيع في هذه الفترة',
    organisationLine: 'متوسط المنظمة',
    organisationShort: 'المتوسط',
    topicsAll: 'المواضيع في كل التقييمات',
    compareWithheld: 'مواضيع لا تظهر لأن عدد من أجابوا عنها في التقييمين أقل من الحد الأدنى:',
    compare: 'قبل وبعد',
    compareHint:
      'اختر تقييما أساسيا وتقييم متابعة. تحسب المقارنة لمن أكمل التقييمين فقط، والتغير لا يعني أن التدريب هو السبب.',
    baseline: 'التقييم الأساسي',
    followUp: 'تقييم المتابعة',
    choose: 'اختر تقييما',
    paired: 'أكملوا التقييمين',
    meanChange: 'تغير متوسط الدرجة',
    changeBy: 'تغير بمقدار',
    interval: 'نطاق الثقة 95%',
    compareSuppressed: 'عدد من أكملوا التقييمين أقل من الحد الأدنى للعرض.',
    compareSame: 'اختر تقييمين مختلفين.',
    courseExams: 'اختبارات الدورات',
    courseExamsHint: 'الاجتياز من المحاولة الأولى ووسيط عدد المحاولات حتى الاجتياز.',
    departments: 'حسب الإدارة',
    open: 'مفتوح',
    closed: 'مغلق',
  },

  training: {
    status: 'حالة البرامج',
    statusHint: 'حالة كل مكلف حتى نهاية الفترة. أربع حالات لا تتداخل.',
    programmes: 'البرامج',
    departments: 'حسب الإدارة',
    bulletins: 'النشرات التوعوية',
    bulletinsHint: 'النشرات المنشورة خلال الفترة، ونسبة من شاهدها من جمهورها.',
    surveys: 'الاستبيانات',
    surveysHint: 'نسبة من أجاب من جمهور كل استبيان.',
    noProgrammes: 'لا توجد برامج مكلف بها أحد',
  },

  policies: {
    policies: 'السياسات',
    policiesHint: 'السياسات المفعلة، والإقرار محسوب على الإصدار الحالي لكل منها.',
    departments: 'حسب الإدارة',
    noPolicies: 'لا توجد سياسات مفعلة لها جمهور',
    status: 'أين يقف المكلفون من كل سياسة',
    statusHint: 'لكل سياسة شريط واحد يساوي من صدرت لهم، مقسما بحسب حالتهم من إصدارها الحالي. الأقل إقرارا أولا.',
  },

  incidents: {
    monthly: 'البلاغات شهريا',
    monthlyHint: 'البلاغات الحقيقية فقط، حسب ما انتهت إليه.',
    outcomes: 'نتيجة المراجعة',
    categories: 'حسب التصنيف',
    departments: 'حسب الإدارة',
    valid: 'صحيح',
    false: 'غير صحيح',
    open: 'قيد المراجعة',
    new: 'جديد',
    inProgress: 'قيد المعالجة',
    simulationRule: 'تستبعد بلاغات رسائل التصيد التجريبية: ما وسمه النظام كمحاكاة، أو ما بدأ نصه بعبارة البلاغ الآلي.',
    noReports: 'لا توجد بلاغات في هذه الفترة',
  },

  followUp: {
    list: 'القائمة',
    search: 'ابحث بالاسم أو الإدارة أو البند',
    empty: 'لا يوجد أحد في هذه القائمة',
    total: 'شخص',
  },

  /* Follow-up status codes — see FollowUpRowDto.Status. */
  status: {
    clicked: 'نقر',
    submitted: 'أدخل بيانات',
    notStarted: 'لم يبدأ',
    inProgress: 'قيد التقدم',
    notOpened: 'لم يطلع',
    downloadedOnly: 'حمل ولم يقر',
    olderVersionOnly: 'أقر بإصدار سابق',
    rejected: 'رفض',
    notTaken: 'لم يجر التقييم',
    failed: 'لم يجتز',
  },

  notes: {
    reported: 'ثم أبلغ',
    open: 'التقييم مفتوح',
    closed: 'التقييم مغلق',
  },

  profile: {
    title: 'ملف الإدارة',
    indicators: 'الإدارة مقابل المنظمة',
    department: 'الإدارة',
    organisation: 'المنظمة',
    people: 'الموظفون',
    peopleHint: 'لكل موظف: أبعد مرحلة في حملات الفترة، والتدريب، والسياسات المعلقة، ونتيجة التقييم.',
    reported: 'أبلغ',
    tickLegend: 'العلامة على كل شريط: نسبة المنظمة',
    above: 'أعلى من المنظمة بـ',
    below: 'أقل من المنظمة بـ',
    same: 'مثل المنظمة',
  },

  /* The chart panels' short captions and the words drawn on the charts. */
  charts: {
    outcomes: 'نتائج حملات التصيد',
    outcomesByMonth: 'نسبة الرسائل المستلمة، حسب الشهر',
    outcomesByCampaign: 'نسبة الرسائل المستلمة، حسب الحملة',
    riskMatrix: 'مصفوفة مخاطر الإدارات',
    riskCaption: 'النقر على التصيد مقابل الإبلاغ عنه',
    riskHint: 'كل دائرة إدارة، موضعها نسبة النقر فيها ونسبة الإبلاغ، وحجمها عدد موظفيها. الخطان المتقطعان نسبتا المنظمة. لا تظهر الإدارات التي حجب أحد معدليها لقلة عددها.',
    bubbleSize: 'حجم الدائرة يمثل عدد الموظفين',
    resilient: 'صامدة',
    attention: 'تحتاج إلى متابعة',
    coverageCaption: 'النسبة في نهاية كل ربع',
    needsActionCaption: 'أشخاص تجب متابعتهم',
    matrixCaption: 'كل إدارة مقابل المنظمة',
    departmentsCaption: 'كل إدارة على خط المنظمة',
    templates: 'نسبة النقر حسب القالب',
    templatesCaption: 'القوالب الأكثر إيقاعا أولا',
    distributionCaption: 'عدد المكملين في كل فئة درجات',
    score: 'الدرجة من 100',
    weakTopics: 'مواضيع تحتاج إلى تعزيز',
    weakTopicsCaption: 'نسبة الإجابات الخاطئة في كل موضوع',
    incorrect: 'إجابات خاطئة',
    improvementCaption: 'متوسط النتيجة لمن أجرى التقييمين',
    activity: 'نشاط التعلم',
    activityCaption: 'إكمال البرامج التدريبية يوما بيوم',
    fewer: 'أقل',
    more: 'أكثر',
    busiestDay: 'أكثر الأيام نشاطا',
    completions: 'حالة إكمال',
    noActivity: 'لم يكمل أحد برنامجا تدريبيا في هذه الفترة',
    programmesCaption: 'نسبة الموظفين المكلفين في كل برنامج',
    acceptance: 'حالة الإقرار بالسياسات',
    acceptanceCaption: 'من جميع تكليفات السياسات',
    acknowledgedShort: 'أقروا',
    policiesCaption: 'حالة الموظفين المكلفين في كل سياسة',
    monthlyCaption: 'البلاغات حسب نتيجة المراجعة',
    outcomeCaption: 'جميع بلاغات الفترة',
    reportsShort: 'بلاغا',
    categoriesCaption: 'عدد البلاغات في كل تصنيف',
    day: 'اليوم',
    weekdays: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    weekdaysShort: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  },

  /* DepartmentPersonDto.PhishingStage */
  stages: {
    none: 'لم تصله حملة',
    delivered: 'وصلته',
    opened: 'فتحها',
    clicked: 'نقر',
    submitted: 'أدخل بيانات',
  },

  /* DepartmentPersonDto.Assessment */
  assessmentStatus: {
    passed: 'اجتاز',
    failed: 'لم يجتز',
    notTaken: 'لم يجره',
    none: 'غير مكلف',
  },

  /* The simple reports (2026-10-25): one tab per part of the system, and the same four blocks on
     each — the figures, where everyone stands, the list of items, the departments. Plain words:
     a figure says what was counted and out of how many, nothing more. */
  simple: {
    tabs: {
      summary: 'نظرة عامة',
      users: 'المستخدمون',
      training: 'التدريب',
      knowledge: 'القياسات',
      phishing: 'التصيد',
      policies: 'السياسات',
      bulletins: 'النشرات',
      surveys: 'الاستبيانات',
      incidents: 'الحوادث',
      followUp: 'المتابعة',
    },

    common: {
      department: 'الإدارة',
      employees: 'الموظفون',
      noData: 'لا توجد بيانات في هذه الفترة',
      noRows: 'لا توجد بيانات',
      fewer: 'عدد قليل من الموظفين، فلا تعرض النسبة',
      of: 'من أصل',
      open: 'مفتوح',
      closed: 'مغلق',
      people: 'موظف',
      figures: 'الأرقام الرئيسية',
      top: 'الأعلى',
      lowest: 'الأقل',
      scopePeriod: 'الفترة',
      scopePeople: 'الموظفون المشمولون',
    },

    overview: {
      modules: 'التقارير',
      followUp: 'تحتاج إلى متابعة',
      followUpHint: 'عدد الموظفين في كل قائمة',
      openList: 'عرض القائمة',
      users: 'نشطون خلال الفترة',
      training: 'أكملوا التدريب',
      knowledge: 'اجتازوا القياسات',
      phishing: 'نقروا على رابط التصيد',
      policies: 'أقروا بالسياسات',
      bulletins: 'شاهدوا النشرات',
      surveys: 'أجابوا عن الاستبيانات',
      incidents: 'بلاغا خلال الفترة',
      incidentsValid: 'منها صحيحة',
      unitPeople: 'موظف',
      unitAssignments: 'تكليف',
      unitParticipants: 'مشارك',
      unitEmails: 'رسالة',
      unitAudience: 'مستهدف',
    },

    users: {
      /* What each figure card counts — behind its (i). */
      info: {
        total: 'عدد الموظفين أصحاب الحسابات الفعالة المشمولين في الفترة المختارة. منهم تحسب نسب هذا التقرير.',
        active: 'الموظفون الذين سجلوا الدخول إلى المنصة مرة واحدة على الأقل خلال الفترة. النسبة من إجمالي الموظفين.',
        inactive: 'موظفون حساباتهم فعالة لكنهم لم يسجلوا الدخول خلال الفترة.',
        notActive: 'حسابات لا تدخل في التقارير: بانتظار التفعيل، أو موقوفة، أو منتهية أو غادر أصحابها.',
      },
      total: 'إجمالي الموظفين',
      totalHint: 'الحسابات الفعالة',
      active: 'نشطون',
      ofEmployees: 'من الموظفين',
      inactive: 'غير نشطين',
      inactiveHint: 'لم يسجلوا الدخول',
      notActive: 'حسابات غير فعالة',
      notActiveHint: 'بانتظار التفعيل أو موقوفة',
      activity: 'نشاط الموظفين خلال الفترة',
      accounts: 'حالة الحسابات',
      inScope: 'فعالة',
      awaiting: 'بانتظار التفعيل',
      suspended: 'موقوفة',
      left: 'منتهية أو غادر أصحابها',
      unit: 'موظف',
      accountsUnit: 'حساب',
      byDepartment: 'المستخدمون حسب الإدارة',
      activeRate: 'نسبة النشاط',
    },

    training: {
      /* What each figure card counts — behind its (i). */
      info: {
        programmes:
          'عدد البرامج التدريبية المشمولة في الفترة المختارة، ومنها الجارية اليوم: بدأت أولى دوراتها ولم تنته آخرها.',
        assignments: 'كل تكليف هو موظف واحد في برنامج واحد، فالموظف المكلف بثلاثة برامج يحسب ثلاث مرات.',
        completed: 'التكليفات التي أكملها أصحابها حتى نهاية الفترة، نجحوا فيها أو لم ينجحوا. النسبة من إجمالي التكليفات.',
        overdue: 'تكليفات تجاوزت آخر موعد لإنجاز دوراتها ولم تكتمل حتى نهاية الفترة.',
      },
      programmes: 'البرامج التدريبية',
      runningNow: 'الجارية اليوم:',
      /* Where each programme stands today, from its courses' dates — ProgramRowDto.Status. */
      state: 'حالة البرنامج',
      states: { running: 'جاري', upcoming: 'لم يبدأ', ended: 'منتهي' },
      assignments: 'التكليفات',
      assignmentsHint: 'كل موظف في كل برنامج كلف به',
      completed: 'أكملوا',
      ofAssignments: 'من التكليفات',
      overdue: 'متأخرون',
      overdueHint: 'تجاوزوا موعد الإنجاز',
      status: 'حالة التدريب',
      byProgramme: 'الإكمال حسب البرنامج',
      passed: 'أكملوا ونجحوا',
      failed: 'أكملوا ولم ينجحوا',
      inProgress: 'قيد التقدم',
      notStarted: 'لم يبدؤوا',
      unit: 'تكليف',
      programme: 'البرنامج',
      assigned: 'المكلفون',
      completion: 'نسبة الإكمال',
      byDepartment: 'التدريب حسب الإدارة',
    },

    knowledge: {
      /* What each figure card counts — behind its (i). */
      info: {
        assessments: 'عدد القياسات المشمولة في الفترة المختارة.',
        audience: 'كل موظف في كل قياس كلف به، فالموظف المكلف بقياسين يحسب مرتين.',
        participated: 'من أكملوا القياس من بين المستهدفين به. النسبة من المستهدفين.',
        passed: 'من بلغوا درجة النجاح من بين من شاركوا. النسبة من المشاركين.',
      },
      assessments: 'القياسات',
      audience: 'المستهدفون',
      audienceHint: 'كل موظف في كل قياس كلف به',
      participated: 'شاركوا',
      ofAudience: 'من المستهدفين',
      passed: 'اجتازوا',
      ofParticipants: 'من المشاركين',
      results: 'نتائج القياسات',
      journey: 'من التكليف إلى الاجتياز',
      byAssessment: 'الاجتياز حسب القياس',
      failed: 'لم يجتازوا',
      notTaken: 'لم يشاركوا',
      unit: 'مستهدف',
      assessment: 'القياس',
      state: 'الحالة',
      participation: 'نسبة المشاركة',
      passRate: 'نسبة الاجتياز',
      meanScore: 'متوسط الدرجة',
      byDepartment: 'القياسات حسب الإدارة',
    },

    phishing: {
      /* What each figure card counts — behind its (i). */
      info: {
        campaigns: 'حملات التصيد التجريبية التي أطلقت خلال الفترة.',
        sent: 'رسائل التصيد التجريبية التي وصلت إلى الموظفين في هذه الحملات.',
        clicked: 'الرسائل التي نقر مستلموها على رابطها، ومنها ما أدخل فيه بيانات. النسبة من الرسائل المرسلة، وكلما قلت كان أفضل.',
        reported: 'الرسائل التي أبلغ عنها مستلموها بوصفها تصيدا. النسبة من الرسائل المرسلة، وكلما زادت كان أفضل.',
      },
      campaigns: 'الحملات',
      sent: 'رسائل أرسلت',
      clicked: 'نقروا على الرابط',
      reported: 'أبلغوا عن الرسالة',
      ofEmails: 'من الرسائل',
      outcome: 'ماذا فعل الموظفون بالرسائل',
      journey: 'إلى أين وصلت الرسائل',
      submitted: 'أدخلوا بياناتهم',
      clickedOnly: 'نقروا ولم يدخلوا بيانات',
      reportedOnly: 'أبلغوا دون أن ينقروا',
      ignored: 'لم يتفاعلوا',
      unit: 'رسالة',
      campaign: 'الحملة',
      launched: 'تاريخ الإطلاق',
      sentShort: 'أرسلت',
      clickedShort: 'نقروا',
      submittedShort: 'أدخلوا بيانات',
      reportedShort: 'أبلغوا',
      byDepartment: 'التصيد حسب الإدارة',
    },

    policies: {
      /* What each figure card counts — behind its (i). */
      info: {
        policies: 'عدد السياسات المشمولة في الفترة المختارة.',
        assignments: 'كل تكليف هو موظف واحد في سياسة واحدة، فالموظف المكلف بسياستين يحسب مرتين.',
        acknowledged: 'التكليفات التي أقر بها أصحابها حتى نهاية الفترة. النسبة من إجمالي التكليفات.',
        pending: 'تكليفات لم يقر بها أصحابها ولم يرفضوها حتى نهاية الفترة.',
      },
      policies: 'السياسات',
      assignments: 'التكليفات',
      assignmentsHint: 'كل موظف في كل سياسة كلف بها',
      acknowledged: 'أقروا',
      ofAssignments: 'من التكليفات',
      pending: 'بانتظار الإقرار',
      status: 'حالة الإقرار بالسياسات',
      byPolicy: 'الإقرار حسب السياسة',
      rejected: 'رفضوا',
      unit: 'تكليف',
      policy: 'السياسة',
      version: 'الإصدار',
      assigned: 'المكلفون',
      rate: 'نسبة الإقرار',
      byDepartment: 'السياسات حسب الإدارة',
    },

    bulletins: {
      /* What each figure card counts — behind its (i). */
      info: {
        bulletins: 'النشرات التوعوية التي نشرت خلال الفترة.',
        audience: 'مجموع من وجهت إليهم هذه النشرات، فالموظف المستهدف بنشرتين يحسب مرتين.',
        viewed: 'من فتحوا النشرة من بين المستهدفين بها.',
        rate: 'من شاهدوا النشرات من بين المستهدفين بها، بعد استبعاد ما لا تعرض نسبته لقلة عدد الموظفين.',
      },
      bulletins: 'النشرات المنشورة',
      audience: 'المستهدفون',
      viewed: 'شاهدوها',
      rate: 'نسبة المشاهدة',
      reach: 'وصول النشرات',
      byBulletin: 'المشاهدة حسب النشرة',
      notViewed: 'لم يشاهدوها',
      unit: 'مستهدف',
      bulletin: 'النشرة',
      published: 'تاريخ النشر',
      list: 'النشرات',
    },

    surveys: {
      /* What each figure card counts — behind its (i). */
      info: {
        surveys: 'الاستبيانات التي كانت مفتوحة خلال الفترة.',
        audience: 'مجموع من كلفوا بهذه الاستبيانات، فالموظف المكلف باستبيانين يحسب مرتين.',
        answered: 'من أرسلوا إجاباتهم من بين المكلفين.',
        rate: 'من أجابوا من بين المكلفين بالاستبيانات، بعد استبعاد ما لا تعرض نسبته لقلة عدد الموظفين.',
      },
      surveys: 'الاستبيانات',
      audience: 'المكلفون',
      answered: 'أجابوا',
      rate: 'نسبة الاستجابة',
      response: 'الاستجابة للاستبيانات',
      bySurvey: 'الاستجابة حسب الاستبيان',
      notAnswered: 'لم يجيبوا',
      unit: 'مكلف',
      survey: 'الاستبيان',
      period: 'الفترة',
      list: 'الاستبيانات',
    },

    incidents: {
      /* What each figure card counts — behind its (i). */
      info: {
        reports: 'البلاغات الأمنية التي رفعها الموظفون خلال الفترة.',
        valid: 'بلاغات راجعها المختصون ووجدوها صحيحة. النسبة من كل البلاغات.',
        false: 'بلاغات راجعها المختصون ووجدوها غير صحيحة.',
        open: 'بلاغات جديدة لم تراجع بعد، أو ما زالت قيد المراجعة.',
      },
      reports: 'البلاغات',
      valid: 'صحيحة',
      false: 'غير صحيحة',
      open: 'قيد المعالجة',
      openHint: 'جديدة أو قيد المراجعة',
      ofReports: 'من البلاغات',
      topCategories: 'أكثر التصنيفات بلاغا',
      review: 'نتيجة مراجعة البلاغات',
      isNew: 'جديدة',
      inProgress: 'قيد المراجعة',
      unit: 'بلاغ',
      category: 'التصنيف',
      parent: 'التصنيف الرئيسي',
      count: 'عدد البلاغات',
      byCategory: 'البلاغات حسب التصنيف',
      reporters: 'موظفون أبلغوا',
      participation: 'نسبة المشاركة',
      byDepartment: 'البلاغات حسب الإدارة',
    },
  },
}
